import React, { useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Toolbar,
  Typography,
  Paper,
} from "@mui/material";

import DamagedRawMaterials from "./DamagedRawMaterials";
import DamagedProducts from "./DamagedProducts";

const DamagedMaterials = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f6f7fb" }}>
      <Toolbar />

      <Box sx={{ px: { xs: 2, md: 4 }, pt: '50px' }}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: "16px",
            border: "1px solid #e7e7e7",
            backgroundColor: "#fff",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              px: { xs: 2, md: 3 },
              py: 2,
              display: "flex",
              alignItems: { xs: "flex-start", md: "center" },
              justifyContent: "space-between",
              flexDirection: { xs: "column", md: "row" },
              gap: 1,
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: "18px", fontWeight: 800, color: "#111" }}>
                Damaged Stock Entry
              </Typography>
              <Typography sx={{ fontSize: "13px", color: "#6b7280", mt: 0.5 }}>
                Log damaged raw materials or finished products from your outlet stock.
              </Typography>
            </Box>

            <Box
              sx={{
                px: 1.5,
                py: 0.75,
                borderRadius: "999px",
                backgroundColor: "#f3f4f6",
                fontSize: "12px",
                color: "#111827",
                fontWeight: 700,
                width: "fit-content",
              }}
            >
              Outlet Damage Register
            </Box>
          </Box>

          {/* Tabs */}
          <Box sx={{ px: { xs: 1.5, md: 2 }, py: 1.5 }}>
            <Tabs
              value={tab}
              onChange={(e, v) => setTab(v)}
              variant="fullWidth"
              sx={{
                minHeight: 48,
                backgroundColor: "#f3f4f6",
                borderRadius: "14px",
                p: "6px",
                "& .MuiTabs-indicator": { display: "none" }, // hide default indicator
                "& .MuiTab-root": {
                  minHeight: 40,
                  borderRadius: "12px",
                  textTransform: "none",
                  fontWeight: 800,
                  fontSize: "14px",
                  color: "#374151",
                },
                "& .Mui-selected": {
                  backgroundColor: "#003049",
                  color: "#fff !important",
                  boxShadow: "0 6px 18px rgba(0, 48, 73, 0.18)",
                },
              }}
            >
              <Tab label="Damaged Raw Materials" />
              <Tab label="Damaged Products" />
            </Tabs>
          </Box>
        </Paper>

        {/* Content container */}
        <Paper
          elevation={0}
          sx={{
            mt: 2,
            borderRadius: "16px",
            border: "1px solid #e7e7e7",
            backgroundColor: "#fff",
            overflow: "hidden",
          }}
        >
          <Box sx={{ p: { xs: 1.5, md: 2 } }}>
            {tab === 0 && <DamagedRawMaterials />}
            {tab === 1 && <DamagedProducts />}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default DamagedMaterials;
